import {getFetchOpts, json, status} from './fetchLogic';
import * as config from '../../config.json';
const debug = config.debug;

async function getFetch(url, auth) {
  debug && console.log('in fetch');
  const opts = getFetchOpts('GET', auth);
  let result;
  await fetch(url, opts)
      .then(status)
      .then(json)
      .then((data) => {
        debug && console.log('events ', data);
        result = data;
      })
      .catch(function(error) {
        debug && console.log('Request failed', error);
      });
  return result;
}
async function postFetch(url, auth) {
  let result;
  const fullUrl = config.pApiDevBase + url;
  const opts = getFetchOpts('POST', auth);
  await fetch(fullUrl, opts)
      .then(status)
      .then(json)
      .then(function(data) {
        result = data;
      })
      .catch(function(error) {
        debug && console.log('Request failed', error);
      });
  return result;
}
export {getFetch, postFetch};
